import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from "react-redux";
import { storeFactory } from "./store.js";
import LatestTeaserApp from "./apps/LatestTeaserApp";

let latestTeaserRoots = document.getElementsByClassName('latestTeaserRoot');

[].forEach.call(latestTeaserRoots, function(latestTeaserRoot){

	const newsLink = latestTeaserRoot.getAttribute('data-news-link');
	const agendaLink = latestTeaserRoot.getAttribute('data-agenda-link');
	const blogLink = latestTeaserRoot.getAttribute('data-blog-link');

	const tags = latestTeaserRoot.getAttribute('data-tags');
	const contentTypes = latestTeaserRoot.getAttribute('data-content-types');

    ReactDOM.render(
    	<Provider store={storeFactory()}>
			<LatestTeaserApp {...{newsLink, agendaLink, blogLink, tags, contentTypes}} />
		</Provider>,
        latestTeaserRoot
    );
});


// WEBPACK FOOTER //
// ./src/latestTeaser.js